import { connectRoutes } from 'redux-first-router';
import createHistory from 'history/createBrowserHistory';

import queryString from '../helpers/query-string';

import paths from './paths';

const history = createHistory();

const {
  reducer,
  middleware,
  enhancer,
} = connectRoutes(history, paths, {
  querySerializer: queryString,
});

// @HACK Exporting when assigning the variables above works when the application compiles to run,
// however Jest chokes on the reducer when running our snapshot tests.
export {
  reducer,
  middleware,
  enhancer,
};



// WEBPACK FOOTER //
// ./src/routes/index.js